import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'

import { ReactComponent as MoneyCheckDollarPenIcon } from 'assets/MoneyCheckDollarPen.svg'
import { ReactComponent as MoneyCheckDollarPlusIcon } from 'assets/MoneyCheckDollarPlus.svg'
import TooltipMenuItem from 'components/common/TooltipMenuItem'
import AddEditPurchaseOrderDialog from 'components/work-order/purchase-order/AddEditPurchaseOrderDialog'
import T from 'T'

const AddEditPurchaseOrderMenuOption = ({
  workOrderId,
  serviceDate = '',
  configuredServiceId = '',
  existingPurchaseOrder = '',
  isLocked = false,
  onClose,
  onSuccess = noop,
}) => {
  const [isOpenAddEditPurchaseOrderDialog, setIsOpenAddEditPurchaseOrderDialog] = useState(false)

  const handleAddEditPOClick = useCallback(() => setIsOpenAddEditPurchaseOrderDialog(true), [])

  const handleAddEditPOClose = useCallback(() => {
    setIsOpenAddEditPurchaseOrderDialog(false)
    onClose()
  }, [onClose])

  return (
    <>
      <TooltipMenuItem disabled={isLocked} tooltip={T.BILLING_LOCKED} onClick={handleAddEditPOClick}>
        <ListItemIcon>
          {existingPurchaseOrder ? <MoneyCheckDollarPenIcon height={24} width={24} /> : <MoneyCheckDollarPlusIcon height={24} width={24} />}
        </ListItemIcon>
        <ListItemText>{existingPurchaseOrder ? T.EDIT_PURCHASE_ORDER : T.ADD_PURCHASE_ORDER}</ListItemText>
      </TooltipMenuItem>
      <AddEditPurchaseOrderDialog
        configuredServiceId={configuredServiceId}
        existingPurchaseOrder={existingPurchaseOrder}
        isOpen={isOpenAddEditPurchaseOrderDialog}
        serviceDate={serviceDate}
        workOrderId={workOrderId}
        onClose={handleAddEditPOClose}
        onSuccess={onSuccess}
      />
    </>
  )
}

AddEditPurchaseOrderMenuOption.propTypes = {
  workOrderId: PropTypes.string.isRequired,
  serviceDate: PropTypes.string,
  configuredServiceId: PropTypes.string,
  existingPurchaseOrder: PropTypes.string,
  isLocked: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
}

export default AddEditPurchaseOrderMenuOption
